import PopupWarp from './warp.vue'
import PopupLoading from './loading.vue'

export {
  PopupWarp,
  PopupLoading
}
